/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import DropZonesOverlayStateAPI from './DropZonesOverlayStateAPI';
import OverlayModel from '../models/OverlayModel';
import { destroy } from 'mobx-state-tree';
const APIFactory = require('gemini/lib/@waca/dashboard-common/dist/core/APIFactory');

class DropZonesOverlayState {
	constructor(options) {
		this._content = options.content;
		this._features = options.features;
		this._state = this._features['state'];
		this._visualization = this._features['Visualization'];
		this._dashboard = this._features['Dashboard.API'];
		this._dashboardState = this._features['Dashboard.DashboardState'];
		this._previousAuthoringState = this._dashboardState.getUiState().authoring;
	}

	getAPI() {
		return this._api;
	}

	initialize() {
		this._api = APIFactory.createAPI(this, [DropZonesOverlayStateAPI]);
		this._overlayModel = OverlayModel.create({
			slotsModel: {}
		}, {
			dashboardApi: this._dashboard,
			content: this._content
		});
		this._onUiStateChangeCallback = this._onUiStateChange.bind(this);
		this._dashboardState.onUiStateChange(this._onUiStateChangeCallback);
		this._dashboard.on('tab:tabChanged', this._tabChange, this);
	}

	getModel() {
		return this._overlayModel;
	}

	show() {
		this._overlayModel.setOverlayState(true/*display*/);
	}

	hide() {
		this._overlayModel.setOverlayState(false/*display*/);
	}

	destroy() {
		this._dashboardState.offUiStateChange(this._onUiStateChangeCallback);
		this._dashboard.off('tab:tabChanged', this._tabChange, this);
		destroy(this._overlayModel);
		this._dashboard = null;
		this._api = null;
		this._overlayModel = null;
	}

	_whenVisualizationReady() {
		return this._state.whenStatusChanges(this._state.STATUS.RENDERED);
	}

	_onUiStateChange(uiState){
		this._whenVisualizationReady().then(() => {
			if(this._api && this._previousAuthoringState !== uiState.authoring){
				const shouldShow = uiState.authoring && !uiState.eventGroups;
				if(shouldShow && !this._isVisualizationMappingComplete()){
					this.show && this.show();
				} else {
					this.hide && this.hide();
				}
				this._previousAuthoringState = uiState.authoring;
			}
		});
	}

	_tabChange(/*payload*/) {
		return this._whenVisualizationReady().then(() => {
			if(this._api && this._previousAuthoringState && !this._isVisualizationMappingComplete()) {
				this.show && this.show();
			} else {
				this.hide && this.hide();
			}
		});
	}

	_isVisualizationMappingComplete() {
		if (this._visualization) {
			return this._visualization.getSlots().isMappingComplete();
		}
	}
}

module.exports = DropZonesOverlayState;



// WEBPACK FOOTER //
// ./src/js/dashboard/DropZonesOverlayState.js